<template>
  <div id="ProductList" class="page product-list">
    <div class="page-top-container">
      <div class="select-product-block line-no-wrap">
        <span class="block-title after-line">已选产品</span>
        <el-tooltip
            :disabled="selectProduct.model && selectProduct.model.length < 80"
            effect="light"
            :content="selectProduct.model"
            placement="bottom-start"
        >
          <span class="name-span">{{selectProduct.model || '暂无'}}</span>
        </el-tooltip>
        <el-button v-if="selectProduct.id" type="text" @click="chooseDetail(selectProduct)">查看</el-button>
      </div>
      <div class="search-bar">
        <span class="search-bar-title" @click="()=>{ isFold = !isFold }">
          <i class="el-icon-arrow-right rotate-icon" :class="{'icon-fold':isFold}" />
          选型条件
        </span>
        <gjw-dimensions @height-changed="searchBoxHeightChange">
          <div class="search-content-box" :class="{'fold-height':isFold}">
            <indoor-unit-search ref="indoorUnitSearch" from="IndoorUnitOthers" :init-value="rowSearch" />
            <div class="search-btn-box">
              <el-button type="primary" size="medium" @click="reChoose">选&nbsp;&nbsp;型</el-button>
            </div>
          </div>
        </gjw-dimensions>
      </div>
    </div>
    <div class="search-innerbox">
      <el-table
        v-if="tableData.length"
        :data="tableData"
        v-loading="tableLoading"
        :max-height="tableHeight"
        :header-row-style="{ height: '40px' }"
        :cell-style="cellStyle"
      >
        <el-table-column prop="model" label="产品型号" min-width="320px">
          <template slot-scope="scope">
            <div class="model-container">
              <span class="img-tab-container">
                <img
                  v-if="scope.row.imageUrl"
                  class="product-img"
                  :src="scope.row.imageUrl"
                  alt=""
                  @error="imageUrlFailed = true"
                />
                <img
                  v-else
                  class="product-img"
                  :src="productImage"
                  alt=""
                  @error="imageUrlFailed = true"
                />
              </span>
              <span class="modelRow" style="color: #4897f5">{{ scope.row.model }}</span>
              <span class="modelRow modeproductSeries">产品系列：{{ scope.row.productSeriesName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name1" label="结构形式" width="180px">
          <template v-slot="{ row }">
            {{ row.name1 || searchData.structuresName }}
          </template>
        </el-table-column>
        <el-table-column
          prop="cold"
          label="制冷量(KW)"
          width="180px"
        >
          <template v-slot="{ row }">
            {{ row.parameters[0].value || "- -" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="heat"
          label="制热量(KW)"
          width="180px"
        >
          <template v-slot="{ row }">
            {{ row.parameters[1].value || "- -" }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140px">
          <template slot-scope="scope">
            <div v-if="selectProduct.id === scope.row.id" class="iconSuccess">
              <i class="el-icon-success"></i>
              <span>已选</span>
            </div>
            <el-button
              v-else
              @click="onSelectRow(scope.$index, scope.row)"
              style="margin-right: 14px; background: #4897f5; color: #fff"
              type="button"
              size="small"
            >选择</el-button>

            <el-button
              @click="chooseDetail(scope.row)"
              type="text"
              size="small"
              style="color: #4897f5"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <empty-content v-else text="根据您的选型条件暂无匹配的产品型号，请修改选型条件后重试" />
      <!-- 抽屉 -->
      <el-drawer
        close-on-click-modal
        custom-class="product-detail-drawer"
        :append-to-body="true"
        :modal="true"
        :direction="direction"
        :visible.sync="drawer"
        :size="drawerWidth"
      >
        <fan-coil-detail :productIds="productId" />
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import FanCoilDetail from './FanCoilDetail.vue'
import IndoorUnitSearch from './components/batchSelection/IndoorUnitSearch.vue'
import GjwDimensions from '@/components/lib/GjwDimensions.vue'
import EmptyContent from '@/components/business/EmptyContent.vue'

export default {
  name: 'IndoorUnitOthers',
  props: {
    productRow: {
      type: Array,
      default() {
        return []
      },
    },
    currentRow: {
      type: Object,
      default() {
        return []
      },
    },
    room: {
      type: Object,
      default() {
        return {}
      }
    },
    rowSearch: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  components: {
    FanCoilDetail,
    IndoorUnitSearch,
    GjwDimensions,
    EmptyContent,
  },
  data() {
    return {
      tableLoading: false,
      pageSize: 50,
      // 选型条件是否收起
      isFold: true,
      tableHeight: (document.body.clientHeight - 130).toFixed(0),
      // 房间的产品搜索条件
      searchData: {},
      selectProduct: {
        searchData: {}
      },
      drawer: false,
      productId: '',
      innerDrawer: false,
      direction: 'ltr',
      drawerWidth: '1040px',
      tableData: [],
      imageUrlFailed: false,
      // 品类编码
      gjwCategoryCode: 'C000005',
      // 品类名称
      gjwCategoryName: '多联机',
    }
  },
  computed: {
    ...mapGetters({
      detail: 'productDetail/detail',
    }),
    productImage() {
      return require('@/assets/image/default_product_img.png')
    },
  },

  watch: {
    currentRow: {
      handler(newValue, oldValue) {
        // 触发选型结果
        this.initPage()
      },
    },
  },

  mounted() {
    // 触发选型结果
    this.initPage()
  },

  methods: {
    ...mapActions({
      // 获取产品详情
      loadProperties: 'productDetail/loadProperties',
      loadDetail: 'productDetail/loadDetail',
      loadRelatedComponents: 'productDetail/loadRelatedComponents',
      loadRelatedBlocks: 'productDetail/loadRelatedBlocks',
    }),

    ...mapMutations({
      setProductId: 'productDetail/setProductId',
    }),
    // 初始化页面
    initPage() {
      // 如果未找到合适规格，则不展示表格
      if (this.currentRow.id) {
        const data = this.$refs.indoorUnitSearch.getSearchData()
        this.searchData = { ...data.searchData }
        this.getTableList()
      } else {
        this.selectProduct = {
          searchData: {}
        }
        this.reChooseProductIds = []
        this.tableData = []
      }
    },
    async getTableList(from, productIds) {
      const isReChoose = from === 'reChoose'
      const parameter_values = {
        paramsObj: { productIds: isReChoose ? productIds : this.productRow },
      }
      await this.$api.products.parameter_Undoor_values(parameter_values).then((res) => {
        const that = this
        that.tableData = res
        if (!isReChoose) {
          this.selectProduct = that.tableData.find((item) => { return item.id === this.currentRow.id }) || {}
          this.selectProduct.searchData = { ...this.currentRow.searchData }
          this.reChooseProductIds = [...this.productRow]
        }
      }).finally(() => {
        this.tableLoading = false
      })
    },
    searchBoxHeightChange(obj) {
      const height = obj.newValue || 0
      const maxHeight = document.body.clientHeight - height - 130
      this.tableHeight = maxHeight.toFixed(0)
    },
    // 选择
    onSelectRow(index, row) {
      this.selectProduct = row
      this.selectProduct.searchData = { ...this.searchData }
      const obj = {
        row: { ...this.selectProduct, productIds: this.reChooseProductIds },
        index: index
      }
      this.$emit('selectRow', obj)
      // 选择备选结果埋点
      this.$tracks({
        event: 'selectAlternative',
        params: {
          g_c_class_code: this.gjwCategoryCode,
          g_c_class_name: this.gjwCategoryName,
          g_c_product_id: row.id,
          g_c_product_name: row.name,
        },
      })
    },

    // 设置行样式
    cellStyle({ row }) {
      let cellStyle
      if (this.selectProduct.id === row.id) {
        cellStyle = 'background:#E9F2FE'
      }
      return cellStyle
    },
    // 改变查询条件后，重新选型
    reChoose() {
      this.tableLoading = true
      const data = this.$refs.indoorUnitSearch.getSearchData()
      this.searchData = { ...data.searchData }
      const productProperties = data.productProperties
      const validationProperties = data.validProperties
      const nonValidationProperties = data.nonValidProperties
      const roomInfo = [this.room]
      const paramsForMulti_room = {
        topSize: this.pageSize,
        brandCode: this.searchData.brandCode,
        inputCondition: roomInfo,
        productProperties: productProperties,
        singleUnitResponsibilityArea: this.searchData.singleUnitResponsibilityArea,
        nonValidationProperties: nonValidationProperties,
        validationProperties: validationProperties,
      }
      this.$api.products.getMulti_room(this.gjwCategoryCode, paramsForMulti_room).then((res) => {
        this.reChooseProductIds = res[0].productIds
        if (this.reChooseProductIds && this.reChooseProductIds.length) {
          this.getTableList('reChoose', this.reChooseProductIds)
        } else {
          this.tableLoading = false
          this.tableData = []
        }
      }).catch(() => {
        this.tableLoading = false
        this.$msgbox(
          '存在过大或过小的输入值，请检查是否符合实际情况并重新输入。',
          '提示',
          {
            confirmButtonText: '确定',
            callback: (action) => {
              this.$message({
                type: 'info',
                message: `action: ${action}`,
              })
            },
          }
        )
      })
    },

    // 查看详情
    async chooseDetail(row) {
      this.drawer = true
      this.setProductId(row.id)
      // 获取产品ID
      this.productId = row.id
      // 获取产品详情
      this.loadProperties().then()
      this.loadDetail().then()
      this.loadRelatedComponents().then()
      this.loadRelatedBlocks().then()
      const projectInfo = await this.getProjectInfo()
      // 查看详情埋点
      this.$tracks({
        event: 'visitProductDetail',
        params: {
          g_c_class_code: this.gjwCategoryCode,
          g_c_class_name: this.gjwCategoryName,
          g_c_product_id: row.id,
          g_c_product_name: row.name,
          g_c_source: 'alternative',
          g_c_project_id: projectInfo.id,
          g_c_project_file_path: projectInfo.path,
          g_c_project_file_name: projectInfo.name
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.product-list {
  width: 1110px !important;
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
  font-size: 12px;
  .search-innerbox {
    padding: 0 20px;
    flex: 1;
  }
}
.page-top-container{
  padding: 0 20px;
}
.select-product-block{
  background: #E9F2FE;
  border-radius: 6px;
  padding: 0 14px;
  margin-bottom: 10px;
  height: 32px;
  line-height: 32px;
  .block-title{
    margin-right: 10px;
    padding-right: 10px;
  }
  .name-span{
    margin-right: 10px;
  }
}
.search-bar{
  margin-bottom: 8px;
}
.search-bar-title{
  color: #009ee1;
  cursor: pointer;
  .rotate-icon {
    display: inline-block;
    transform: rotate(90deg);
    transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

    &.icon-fold {
      transform: rotate(0deg);
    }
  }
}
.search-content-box{
  box-sizing: border-box;
  border-top: 1px solid #d2d9e3;
  margin: 8px 0;
  height: 130px;
  overflow: hidden;
  transition: height 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  &.fold-height{
    height: 0;
    border: none;
  }
}
.search-btn-box{
  margin-top: 8px;
  text-align: right;
}

/deep/div.search-innerbox .el-table__row {
  height: 64px !important;
}
/deep/.el-table th {
  padding: 0 !important;
}
/deep/.el-table td {
  padding: 0 !important;
}
/deep/.el-input-number--mini {
  width: 116px;
  line-height: 22px;
}
/deep/.el-button {
  margin-left: 0 !important;
}

.iconSuccess {
  display: unset;
  margin-right: 18px;
  height: 32px;
  width: 60px;
}

.el-icon-success {
  margin: 0 8px;
  color: #4897f5;
}
.model-container {
  .product-img {
    width: 54px;
    height: 54px;
    margin-left: 10px;
    margin-top: 5px;
    background: #f3f3f3;
  }
  .modelRow {
    position: absolute;
    top: 8px;
    margin-left: 4px;
    width: 220px;
  }
  .modeproductSeries {
    top: 30px;
  }
}
</style>
